'use strict';

export default {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};



// WEBPACK FOOTER //
// ./~/axios/lib/defaults/transitional.js